import React from 'react';
import HHTHeader from './components/HHTHeader';
import HHTAbout from './components/HHTAbout';
import HHTProcess from './components/HHTProcess';
import HHTMission from './components/HHTMission';
import HHTInvestment from './components/HHTInvestment';
import HHTTestimonials from './components/HHTTestimonials';
import HHTContact from './components/HHTContact';

const App = () => {
  return (
    <div className="font-sans">
      <HHTHeader />
      <HHTAbout />
      <HHTProcess />
      <HHTMission />
      <HHTInvestment />
      <HHTTestimonials />
      <HHTContact />
    </div>
  );
};

export default App;

// DONE